import Constants from 'config/Constants';
import { set } from 'features/app/appSlice';
import { ToolbarButton } from 'pages/documents_v2/views/edit_area/blocks/ToolbarButton';
import { EditAreaContext } from 'pages/documents_v2/views/edit_area/context/EditAreaContext';
import { idToUri } from 'pages/global/UriHelper';
import { entityTypes } from 'pages/translation/config/Constants';
import { useContext } from 'react';
import { Clipboard2Check, Gear, Share, Stars, Trash } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import RestrictedContent from '../../../../global/RestrictedContent';
import { useEntityTemplateParameters } from '../../../hooks/useEntityTemplateParameters';
import { useGetDocument } from '../../../hooks/useGetDocument';

/**
 * @param {import('models/documents.models').Block} block
 * @param {number} index
 * @param {boolean} isInsideBlockLayout
 */
export function BlockActions({ block, index, isInsideBlockLayout = false }) {
    const { t } = useTranslation();
    const { deleteBlock } = useContext(EditAreaContext);
    const dispatch = useDispatch();
    const document = useGetDocument();
    const restrictions = useEntityTemplateParameters(block, 'block', document);
    const { documentId, areaId } = useParams();

    const hasLinkedBlocks = Object.hasOwn(block, 'linkedBlocks') && block.linkedBlocks.length > 0;
    const hasOpenTask = block.approvalState === 'pending';
    const canDeleteBlock = restrictions?.canDeleteBlock;

    if (!document) {
        return null;
    }

    return (
        <>
            {!isInsideBlockLayout && (
                <>
                    <ToolbarButton
                        tooltip="Taken"
                        disabled={!block.id}
                        onClick={() => handleSettingsIconClick('approvals')}
                    >
                        <Clipboard2Check />
                    </ToolbarButton>

                    <ToolbarButton
                        tooltip={t('global:tooltips.shareLink')}
                        disabled={!block.id}
                        onClick={() => showModal('shareModal')}
                    >
                        <Share />
                    </ToolbarButton>
                </>
            )}

            {document.properties.allowAI && block.type === Constants.blockTypes.text && (
                <RestrictedContent module={Constants.modules.openai}>
                    <ToolbarButton
                        tooltip={t('documents:document.navbar.main.editor.left.blocks.tooltips.improveText')}
                        onClick={() => showModal('blockImprovementModal')}
                    >
                        <Stars className="text-purple" />
                    </ToolbarButton>
                </RestrictedContent>
            )}

            {canDeleteBlock && (
                <ToolbarButton
                    tooltip={
                        hasOpenTask
                            ? t('documents:document.navbar.main.editor.left.blocks.tooltips.deleteBlockTaskOpen')
                            : t('documents:document.navbar.main.editor.left.blocks.tooltips.delete')
                    }
                    onClick={() => deleteBlock(block)}
                    disabled={hasLinkedBlocks || hasOpenTask}
                >
                    <Trash className="text-danger" />
                </ToolbarButton>
            )}

            <ToolbarButton tooltip={'Instellingen'} onClick={() => handleSettingsIconClick()}>
                <Gear />
            </ToolbarButton>
        </>
    );

    function handleSettingsIconClick(landingTab) {
        dispatch(
            set({
                key: 'sidebarContext',
                value: {
                    type: 'sidebarSettings',
                    context: {
                        entity: block,
                        entityType: entityTypes.BLOCK,
                        documentId: parseInt(documentId),
                        areaId: parseInt(areaId),
                        uri: idToUri(block.id, entityTypes.BLOCK),
                        parentUri: idToUri(parseInt(documentId), entityTypes.DOCUMENT),
                        landingTab,
                    },
                },
            }),
        );
    }

    function showModal(eventKey) {
        dispatch(
            set({
                key: 'blockEditModal',
                value: {
                    eventKey,
                    block,
                    blockIndex: index,
                },
            }),
        );
    }
}
